// data validated in AEM
import { CT_LAYOUT } from './constants';
import { TileSizes as TileSizesOldBehaviour, TileSizesNewBehaviour } from './tileSizes';

const FIXED_LAYOUT_SLOTS = {
  [CT_LAYOUT.IRREGULAR_2X1_WIDE]: (index) => {
    if (index === 0) return 'hero';
    if (index === 1) return 'topRight';
    return 'bottomSupport';
  },
  [CT_LAYOUT.IRREGULAR_1X2_SPLIT_ROW]: (index) => (index === 0 ? 'lead' : 'support'),
};

const FIXED_LAYOUTS = {
  [CT_LAYOUT.IRREGULAR_2X1_WIDE]: {
    getSlot: (index) => {
      if (index === 0) return 'hero';
      if (index === 1) return 'topRight';
      return 'bottomSupport';
    },
    slots: {
      hero: {
        desktopRatio: 9 / 16,
        mobileRatio: 9 / 16,
        width: '64%',
      },
      topRight: {
        desktopRatio: 1 / 1,
        mobileRatio: 9 / 16,
        width: '36%',
      },
      bottomSupport: {
        desktopRatio: 9 / 16,
        mobileRatio: 9 / 16,
        width: '33.33%',
      },
    },
  },
  [CT_LAYOUT.IRREGULAR_1X2_SPLIT_ROW]: {
    getSlot: (index) => (index === 0 ? 'lead' : 'support'),
    slots: {
      lead: {
        desktopRatio: 9 / 16,
        mobileRatio: 9 / 16,
        width: '100%',
      },
      support: {
        desktopRatio: 9 / 16,
        mobileRatio: 9 / 16,
        width: '50%',
      },
    },
  },
};

const IRREGULAR_LAYOUTS = new Set([
  CT_LAYOUT.IRREGULAR_2X1_WIDE,
  CT_LAYOUT.IRREGULAR_1X2_SPLIT_ROW,
  CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_RIGHT,
  CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_LEFT,
]);

const LAYOUT_SLOTS = {
  [CT_LAYOUT.IRREGULAR_2X1_WIDE]: FIXED_LAYOUTS[CT_LAYOUT.IRREGULAR_2X1_WIDE].getSlot,
  [CT_LAYOUT.IRREGULAR_1X2_SPLIT_ROW]: FIXED_LAYOUTS[CT_LAYOUT.IRREGULAR_1X2_SPLIT_ROW].getSlot,
  [CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_RIGHT]: (index) => (index === 0 ? 'lead' : 'support'),
  [CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_LEFT]: (index) => (index === 0 ? 'lead' : 'support'),
};

export const getEffectiveLayoutSize = (layoutName, layoutSize) =>
  IRREGULAR_LAYOUTS.has(layoutName) ? 'standard' : layoutSize;

export const getLayoutSlot = (index, layoutName, useNewAspectRatioBehavior) => {
  if (useNewAspectRatioBehavior) {
    const getSlot = LAYOUT_SLOTS[layoutName];

    return getSlot ? getSlot(index) : null;
  }
  return FIXED_LAYOUT_SLOTS[layoutName] ? FIXED_LAYOUT_SLOTS[layoutName](index) : null;
};

export const setTileHeights = (ratio) => ratio * 100;

export const handleSetTileHeights = (index, layoutName, layoutSize, useNewAspectRatioBehavior) => {
  const TileSizes = useNewAspectRatioBehavior ? TileSizesNewBehaviour : TileSizesOldBehaviour;
  if (useNewAspectRatioBehavior) {
    const effectiveLayoutSize = getEffectiveLayoutSize(layoutName, layoutSize);
    const fixedLayout = FIXED_LAYOUTS[layoutName];
    const layoutSlot = fixedLayout ? getLayoutSlot(index, layoutName) : null;

    if (layoutSlot) {
      return setTileHeights(fixedLayout.slots[layoutSlot].desktopRatio);
    }
    if (layoutName === CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_RIGHT && index === 0) {
      return setTileHeights(9 / 8);
    }
    if (layoutName === CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_LEFT && index === 0) {
      return setTileHeights(9 / 8);
    }
    return setTileHeights(TileSizes[layoutName][effectiveLayoutSize]);
  }

  if (layoutName === CT_LAYOUT.IRREGULAR_2X1_WIDE) {
    const height = setTileHeights(TileSizes[layoutName][layoutSize]);
    return index < 2 ? height : height / 2;
  }
  if (layoutName === CT_LAYOUT.IRREGULAR_1X2_SPLIT_ROW) {
    return index === 0
      ? setTileHeights(TileSizes[layoutName].sizeOne[layoutSize])
      : setTileHeights(TileSizes[layoutName].sizeTwo[layoutSize]);
  }
  if (layoutName === CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_RIGHT && index === 2) {
    return setTileHeights(TileSizes[layoutName].sizeTwo[layoutSize]) * 2;
  }
  if (layoutName === CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_LEFT && index === 2) {
    return setTileHeights(TileSizes[layoutName].sizeTwo[layoutSize]) * 2;
  }
  return setTileHeights(TileSizes[layoutName][layoutSize]);
};

export const setMobileTileHeights = (
  index,
  leadCardIndex,
  breakpointLayout,
  layoutSize,
  layoutName,
  useNewAspectRatioBehavior,
) => {
  let tileHeight;
  const TileSizes = useNewAspectRatioBehavior ? TileSizesNewBehaviour : TileSizesOldBehaviour;

  if (useNewAspectRatioBehavior) {
    const effectiveLayoutSize = getEffectiveLayoutSize(layoutName, layoutSize);
    let tileHeight;
    const fixedLayout = FIXED_LAYOUTS[layoutName];
    const layoutSlot = fixedLayout ? getLayoutSlot(index, layoutName) : null;

    if (layoutSlot) {
      return setTileHeights(fixedLayout.slots[layoutSlot].mobileRatio);
    }

    if (!layoutName.includes('Irregular')) {
      return TileSizes[breakpointLayout][effectiveLayoutSize] * 100;
    }

    if (IRREGULAR_LAYOUTS.has(layoutName)) {
      return TileSizes[breakpointLayout].standard * 100;
    }

    if (effectiveLayoutSize === 'short' && index === leadCardIndex) {
      tileHeight = TileSizes[breakpointLayout].standard * 100;
    } else if (index === leadCardIndex) {
      tileHeight = TileSizes[breakpointLayout].tall * 100;
    }

    if (effectiveLayoutSize === 'short' && index !== leadCardIndex) {
      tileHeight = TileSizes[breakpointLayout].short * 100;
    } else if (index !== leadCardIndex) {
      tileHeight = TileSizes[breakpointLayout].standard * 100;
    }

    return tileHeight;
  }

  if (!layoutName.includes('Irregular')) {
    if (layoutName === CT_LAYOUT.BASIC_2X2) {
      return TileSizes[breakpointLayout][layoutSize === 'tall' ? 'standard' : 'short'] * 100;
    }
    return TileSizes[breakpointLayout][layoutSize] * 100;
  }

  if (layoutSize === 'short' && index === leadCardIndex) {
    tileHeight = TileSizes[breakpointLayout].standard * 100;
  } else if (index === leadCardIndex) {
    tileHeight = TileSizes[breakpointLayout].tall * 100;
  }

  if (layoutSize === 'short' && index !== leadCardIndex) {
    tileHeight = TileSizes[breakpointLayout].short * 100;
  } else if (index !== leadCardIndex) {
    tileHeight = TileSizes[breakpointLayout].standard * 100;
  }

  return tileHeight;
};

export const setTileWidths = (index, layoutName, useNewAspectRatioBehavior) => {
  if (useNewAspectRatioBehavior) {
    const fixedLayout = FIXED_LAYOUTS[layoutName];
    const layoutSlot = fixedLayout ? getLayoutSlot(index, layoutName) : null;

    if (layoutSlot) {
      return fixedLayout.slots[layoutSlot].width;
    }

    switch (layoutName) {
      case CT_LAYOUT.BASIC_2X1:
      case CT_LAYOUT.BASIC_2X2:
        return '50%';
      case CT_LAYOUT.BASIC_3X1:
        return '33.33%';
      case CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_RIGHT:
        return index === 0 ? '50%' : '100%';
      case CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_LEFT:
        return index === 0 ? '50%' : '100%';
    }
  }
  switch (layoutName) {
    case CT_LAYOUT.BASIC_2X1:
    case CT_LAYOUT.BASIC_2X2:
      return '50%';
    case CT_LAYOUT.BASIC_3X1:
      return '33.33%';
    case CT_LAYOUT.IRREGULAR_2X1_WIDE:
      return index === 0 ? '66%' : '33%';
    case CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_RIGHT:
      return index === 2 ? '50%' : '100%';
    case CT_LAYOUT.IRREGULAR_2X1_SPLIT_COLUMN_LEFT:
      return index === 2 ? '50%' : '100%';
    case CT_LAYOUT.IRREGULAR_1X2_SPLIT_ROW:
      return index === 0 ? '100%' : '50%';
  }
};

export const keyFor = (tile, index) => ((tile && tile.id) != null ? tile.id : index);
